var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrade = function SvgTrade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    color: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11 13v-2c0-.465 0-.697-.051-.888a1.5 1.5 0 0 0-1.06-1.06C9.696 9 9.464 9 9 9s-.697 0-.888.051a1.5 1.5 0 0 0-1.06 1.06C7 10.303 7 10.536 7 11v2c0 .465 0 .697.051.888a1.5 1.5 0 0 0 1.06 1.06C8.304 15 8.536 15 9 15s.697 0 .888-.051a1.5 1.5 0 0 0 1.06-1.06C11 13.697 11 13.464 11 13m8-1V8c0-.465 0-.697-.051-.888a1.5 1.5 0 0 0-1.06-1.06C17.697 6 17.464 6 17 6s-.698 0-.888.051a1.5 1.5 0 0 0-1.06 1.06C15 7.304 15 7.536 15 8v4c0 .465 0 .697.051.888a1.5 1.5 0 0 0 1.06 1.06c.191.052.424.052.889.052s.698 0 .888-.051a1.5 1.5 0 0 0 1.06-1.06C19 12.697 19 12.464 19 12M9 9V5m0 10v2m8-11V3m0 11v3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 3v10c0 3.771 0 5.657 1.172 6.828S7.229 21 11 21h10"
  })));
};
export default SvgTrade;